// extracted by mini-css-extract-plugin
module.exports = {"timezoneSetting":"style_timezoneSetting__wRbx7","title":"style_title__sfVXx","tip":"style_tip__q31qp"};